module.exports = __webpack_public_path__ + "img/arrow_drop_down.6b5f2db7.svg";